import { useEffect } from "react";
import { getLogs } from "../../services/Api/superadminService";
import { useSuperAdminLogsStore } from "../../stores/superadmin/logs";
import { showToastError } from "../../services/Toasts/toasts";

const SuperAdminLogsTable = () => {
  const { logs, setLogs } = useSuperAdminLogsStore();

  useEffect(() => {
    getLogs()
      .then((res) => setLogs(res?.data))
      .catch(() => showToastError("Une erreur s'est produite"));
  }, []);

  return (
    <div
      className={` w-full h-[80vh] bg-[#3f3f3f] rounded-md overflow-y-scroll text-white`}
    >
      {logs?.map((log: any) => (
        <p className="m-2">{log}</p>
      ))}
    </div>
  );
};

export default SuperAdminLogsTable;
